'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('db-admin-list', {
      url: '/db-admin/:collection',
      template: '<db-admin-list></db-admin-list>',
      authenticate: 'suite-superadmin'
    });
}



// WEBPACK FOOTER //
// ./client/app/admin/db/list/db-admin-list.routes.js